<template>
  <v-autocomplete
    outlined
    hide-details
    return-object
    no-filter
    hide-selected
    hide-no-data
    :clearable="true"
    item-text="nome"
    item-value="id"
    label="Cliente"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @change="onChange"
    v-bind="$attrs"
  >
    <template v-slot:item="{item}">
      <v-list-item-avatar>
        <v-icon x-large :color="item.cor">mdi-account-circle</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>
          {{ item.nome }}
        </v-list-item-title>
      </v-list-item-content>
    </template>
    <template v-slot:append-outer>
      <tw-cadastro-cliente @update="searchData(search)">
        <template v-slot:activator="{ on }">
          <v-btn
            tooltip="Adicionar cliente"
            color="primary"
            icon
            v-on="on">
            <v-icon x-large>mdi-plus-circle</v-icon>
          </v-btn>
        </template>
      </tw-cadastro-cliente>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import ClienteService from '@/api/cliente-service';
import { isObject } from 'lodash';
import CadastroCliente from '@/modules/cliente/CadastroCliente.vue';

const DEFAULT_LIMIT = 100;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: [Object, Array],
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      this.debounceSearch(val);
    },
    value(newValue, oldValue) {
      if (newValue === oldValue || !newValue || !newValue.id) {
        return;
      }
      if (!this.items || !this.items.length) {
        this.items = [newValue];
        return;
      }
      const exists = this.items.find((i) => i.id === newValue.id);
      if (exists) {
        return;
      }
      this.items.push(newValue);
    },
  },
  methods: {
    remove(item) {
      const index = this.localValue.findIndex((a) => a.id === item.id);
      if (index >= 0) this.localValue.splice(index, 1);
    },
    searchData(val) {
      if (this.localValue && this.localValue.nome === val) {
        return;
      }

      this.loading = true;

      const query = `(nome like "%${(val || '')}%") order by nome asc`;

      ClienteService.list({
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query,
      })
        .then((response) => {
          this.items = response.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onChange(event) {
      this.$emit('change', event);
    },
  },
  components: {
    TwCadastroCliente: CadastroCliente,
  },
  created() {
    this.debounceSearch = debounce(this.searchData, 200);
    if (!this.value) {
      return;
    }
    if (isObject(this.value)) {
      this.items = [this.value];
    } else {
      this.items = [...this.items, ...this.value];
    }
  },
};
</script>
